"use strict";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractClient = void 0;
const ethers_1 = require("ethers");
class ContractClient {
    constructor(sdk) {
        this._sdk = sdk;
    }
    static create(sdk) {
        return new ContractClient(sdk);
    }
    get perMill() {
        return ethers_1.BigNumber.from(1e6);
    }
    get perBill() {
        return ethers_1.BigNumber.from(1e9);
    }
    get perTrill() {
        return ethers_1.BigNumber.from(1e12);
    }
    async latestRewardCollected(indexer) {
        if (!ethers_1.utils.isAddress(indexer))
            throw new Error(`Invalid address: ${indexer}`);
        const [currentEra, { lastClaimEra }, lastSettledEra] = await Promise.all([
            this._sdk.eraManager.eraNumber(),
            this._sdk.rewardsDistributor.getRewardInfo(indexer),
            this._sdk.rewardsStaking.getLastSettledEra(indexer),
        ]);
        return currentEra.eq(lastClaimEra.add(1)) && lastSettledEra.lte(lastClaimEra);
    }
    async dailyRewardCap(indexer) {
        if (!ethers_1.utils.isAddress(indexer))
            throw new Error(`Invalid address: ${indexer}`);
        const threshold = await this._sdk.serviceAgreementRegistry.threshold();
        const totalStakingAmount = await this._sdk.stakingManager.getTotalStakingAmount(indexer);
        if (!threshold || threshold.eq(0))
            return ethers_1.BigNumber.from(0);
        return totalStakingAmount.mul(this.perMill).div(threshold);
    }
    async dailyRewardCapcity(indexer) {
        if (!ethers_1.utils.isAddress(indexer))
            throw new Error(`Invalid address: ${indexer}`);
        const dailyRewardCap = await this.dailyRewardCap(indexer);
        const sumDailyReward = await this._sdk.serviceAgreementRegistry.sumDailyReward(indexer);
        return dailyRewardCap.gt(sumDailyReward)
            ? dailyRewardCap.sub(sumDailyReward)
            : ethers_1.BigNumber.from(0);
    }
    async cancelOfferUnspentBalance(offerId) {
        const offer = await this._sdk.purchaseOfferMarket.offers(offerId);
        if (offer.deposit.eq(0))
            throw new Error(`Invalid offerId: ${offerId}`);
        const unspentValue = offer.deposit.mul(offer.limit - offer.numAcceptedContracts);
        return unspentValue;
    }
    async cancelOfferPenaltyFee(offerId) {
        const offer = await this._sdk.purchaseOfferMarket.offers(offerId);
        if (offer.deposit.eq(0))
            throw new Error(`Invalid offerId: ${offerId}`);
        const penaltyRate = await this._sdk.purchaseOfferMarket.penaltyRate();
        const unspentValue = await this.cancelOfferUnspentBalance(offerId);
        const penaltyFee = penaltyRate.mul(unspentValue).div(this.perMill);
        return penaltyFee;
    }
    async canStartNewUnbonding(account) {
        const staking = this._sdk.staking;
        const [maxUnbondingRequest, unbondingLength, withdrawLength] = await Promise.all([
            staking.maxUnbondingRequest(),
            staking.unbondingLength(account),
            staking.withdrawnLength(account),
        ]);
        return unbondingLength.sub(withdrawLength).lt(maxUnbondingRequest.sub(1));
    }
}
exports.ContractClient = ContractClient;
//# sourceMappingURL=contractClient.js.map